import React, { useState } from 'react';
import { Container, Typography, Box, Grid, TextField, InputAdornment, useTheme, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ResourceCard } from '../components/ResourceCard';
import { ResourceDetailModal } from '../components/ResourceDetailModal'; 
import mockResources from '../data/mockResources.json';


export const ExploreResources = () => {
    const theme = useTheme();
    
    const [searchTerm, setSearchTerm] = useState(''); 
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedResource, setSelectedResource] = useState(null); 
    
    const handleViewDetails = (resource) => { 
        if (resource) {
            setSelectedResource(resource);
            setIsModalOpen(true);
        }
    };
    
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedResource(null);
    };

    const filteredResources = mockResources.filter(resource => 
        resource.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        resource.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())) ||
        resource.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <Container maxWidth="xl" sx={{ py: 4 }}>
                <Typography 
                    variant="h2" 
                    gutterBottom 
                    sx={{ fontWeight: 700, mb: 1, color: theme.palette.primary.dark }}
                >
                    Resource Explorer
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                    Connect with vital community resources like Housing, Jobs, and Mental Health support.
                </Typography>

                {/* Search Bar */}
                <Paper 
                    elevation={3} 
                    sx={{ p: 2, mb: 4, borderRadius: 3, bgcolor: theme.palette.background.paper }}
                >
                    <TextField
                        fullWidth
                        label="Search for resources by category, keyword, or location..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            sx: { borderRadius: 2 }
                        }}
                    />
                </Paper>

                {/* Results (Resource Card Grid) */}
                <Box sx={{ mt: 3 }}>
                    <Grid container spacing={4}>
                        {filteredResources.map((resource, index) => (
                            <Grid 
                                item 
                                key={resource.id} 
                                xs={12}    // 1 card per row on mobile
                                sm={6}     // 2 cards per row on small tablets
                                md={4}     // 3 cards per row on standard desktop
                                lg={4}     // 3 cards per row on large desktop
                            >
                                <ResourceCard 
                                    resource={resource} 
                                    index={index} 
                                    onViewDetails={handleViewDetails}
                                />
                            </Grid>
                        ))}
                        {filteredResources.length === 0 && (
                            <Grid item xs={12}>
                                <Typography color="text.secondary" align="center" sx={{ mt: 4 }}>
                                    No resources found matching "{searchTerm}". Try a different search term.
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </Box>

            </Container>
            
            {/* Resource Detail Modal */}
            <ResourceDetailModal
                open={isModalOpen}
                handleClose={handleCloseModal}
                resource={selectedResource}
            />
        </>
    );
};